/**
 * Zngly Lead Tracker
 * Body params: zntrk, zncid
 */

import { toast } from 'react-toastify';
import { TelemetryRunner } from './TelemetryRunner';
import { CookieHandler } from './cookie-init';

function main() {
  const urlParams = new URL(window.location.href).searchParams;
  const zntrk = urlParams.get('zntrk');

  if (!zntrk) {
    return;
  }

  // prevent friendly fire
  const isPreview = urlParams.get('preview') === 'true';
  if (isPreview) {
    setTimeout(() => {
      toast.error('Zngly Lead Tracker is disabled while logged in. Only send the link to your customers.');
    }, 2000);
    return;
  }

  const zncid = CookieHandler.getZnClientId();
  if (!zncid) {
    return;
  }

  const params = new URLSearchParams({
    zntrk,
    zncid,
  });

  // initial call to collect zntrk
  fetch(`${window.location.origin}/api/v0/zntrk/collect`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: params,
  }).then(async (response) => {
    if (!response.ok) {
      return;
    }

    const data = (await response.json()) as { email?: string; ids?: string; error?: string };

    if (!data) {
      return;
    }

    if (data?.error) {
      // toast may not be available
      setTimeout(() => {
        toast.error(data.error);
      }, 500);
      return;
    }

    if (!data?.email) {
      return;
    }

    TelemetryRunner.addGtagLoadedFunction(() => {
      const decodeFn = (val?: string) => {
        if (!val) {
          return null;
        }

        try {
          return JSON.parse(atob(val));
        } catch (e) {
          return null;
        }
      };

      const email = decodeFn(data?.email) as string | null;
      const ids = (decodeFn(data?.ids) as string[] | null) ?? [];
      if (email) {
        // delay to ensure hubspot is loaded
        setTimeout(() => {
          const newLocation = new URL(window.location.href);
          newLocation.searchParams.delete('zntrk');

          if (!window?._hsq) {
            window._hsq = [];
          }

          window?._hsq?.push?.(['setPath', newLocation.pathname + newLocation.search]);
          window?._hsq?.push?.(['identify', { email, zngly_visitor_ids: JSON.stringify(ids) }]);
          window?._hsq?.push?.(['trackPageView']);

          // @todo: umami
          // @ts-ignore
          window?.umami?.identify?.({ email });

          // remove the zntrk from the url
          window.history.replaceState(
            {
              ...window.history.state,
            },
            '',
            newLocation.href
          );
        }, 500);
      }
    });
    //
  });
}

main();
